"use client";

// src/components/popover/popover.tsx
import { useEffect, useRef } from "react";
import { tv } from "tailwind-variants";
import { jsx } from "react/jsx-runtime";
var styles = tv({
  base: "max-w-full max-h-full z-50"
});
var Popover = ({
  open = true,
  autoFocus = true,
  className,
  onClickOutside,
  children,
  role = "",
  ...props
}) => {
  const popupRef = useRef(null);
  useEffect(() => {
    if (typeof onClickOutside !== "function") return;
    const handleClickOutside = (e) => {
      const insidePopover = popupRef.current?.contains(e.target);
      if (insidePopover === false) {
        onClickOutside();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClickOutside]);
  useEffect(() => {
    if (open && autoFocus) {
      popupRef.current?.focus();
    }
  }, [open, autoFocus]);
  return open && /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      ref: popupRef,
      className: styles({ className }),
      role,
      children
    }
  );
};
export {
  Popover
};
